'use client';

import { useTranslations } from 'next-intl';
import { Progress } from '@/components/ui/progress';
import { LanguageLevel } from '@/constants/languageLevel';
import { Language } from '@/constants/languageLevel';
import { getLanguageLevelPercentage, levelMapping } from '@/lib/languagesUtils';

interface LanguageProficiencyDisplayProps {
  languages: Language[];
  className?: string;
}

export function LanguageProficiencyDisplay({
  languages,
  className = '',
}: LanguageProficiencyDisplayProps) {
  const tLanguages = useTranslations('spokenLanguages');
  const tLanguagesLevel = useTranslations('languagesLevel');

  if (!languages || languages.length === 0) {
    return null;
  }

  return (
    <div className={`space-y-6 ${className}`}>
      {languages
        .filter((language) => language.language !== null)
        .map((language) => (
          <div
            key={language.language}
            className='flex max-w-[483px] flex-col gap-2'
          >
            <h1>{tLanguages(language.language)}</h1>
            {language.level && (
              <>
                <Progress
                  value={getLanguageLevelPercentage(
                    language.level as LanguageLevel
                  )}
                  className='w-full'
                />
                <div className='text-black-300 text-xs font-medium'>
                  {tLanguagesLevel(levelMapping[language.level])}
                </div>
              </>
            )}
          </div>
        ))}
    </div>
  );
}
